import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('document', '/documents')
const reducer = generator.generate()

export default reducer
